import React from 'react'
import Modal from 'react-modal'
import {get} from 'lodash'
import eraseCookie from '../../../utilities/session/removeCookie'
import '../../../styles/css/components/structure/session/bk-flow-session-modal.css'

const BkFlowSessionModal = props => {
  const {
    configData,
  } = props

  let hotelLabels = get(configData, 'hotel.labels[0]')

  const handleRefreshSession = () => {
    eraseCookie('flowSessionId')
    window.location.reload()
  }

  return (
    <Modal
      className={{
        base: 'u-modal u-modal--md',
        afterOpen: 'u-modal--visible',
        beforeClose: 'u-modal--close',
        ariaHideApp: false
      }}
      overlayClassName={{
        base: 'u-fade',
        afterOpen: 'u-fade--visible',
        beforeClose: 'u-fade--visible'
      }}
      isOpen={ true }
      contentLabel="Session Availability Modal"
      shouldCloseOnOverlayClick={ false }
      ariaHideApp={ false }
    >
      <div className="bk-flow-session-modal">
        <div className="u-modal__header">
          <h5 className="u-remove-margin">
            {hotelLabels.sessionTimeoutTitle ?
              hotelLabels.sessionTimeoutTitle
            :
              'Hello? Is anyone there?'
            }
          </h5>
        </div>

        <div className="u-modal__body">
          <p>
            {hotelLabels.sessionTimeoutBody ?
              hotelLabels.sessionTimeoutBody
            :
              'Availability may have changed while you were away. Refresh the page to see up to date availability for your search.'
            }
          </p>

          <div className="bk-flow-session-modal__ctas">
            <button
              className="btn btn-primary"
              onClick={() => handleRefreshSession()}
            >
              {hotelLabels.sessionTimeoutRefreshCta ?
                hotelLabels.sessionTimeoutRefreshCta
              :
                'Refresh Availability'
              }
            </button>

            <a
              className="btn btn-secondary"
              href="/"
            >
              {hotelLabels.sessionTimeoutExitCta ?
                hotelLabels.sessionTimeoutExitCta
                :
                'Back to home page'
              }
            </a>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default BkFlowSessionModal



// WEBPACK FOOTER //
// ./src/components/structure/session/BkFlowSessionModal.js